import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

// Chart.js Module registrieren
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const getNext12MonthLabels = () => {
    const labels = [];
    const now = new Date();
    now.setDate(1); // Normalize to first of the month

    const formatter = new Intl.DateTimeFormat('de-DE', { month: 'short', year: 'numeric' });

    for (let i = 0; i < 12; i++) {
        const date = new Date(now.getFullYear(), now.getMonth() + i, 1);
        labels.push(formatter.format(date));
    }

    return labels;
};

const getMonthLabelsForCurrentYear = () => {
    const labels = [];
    const year = new Date().getFullYear();

    const formatter = new Intl.DateTimeFormat('de-DE', {
        month: 'short',
        year: 'numeric'
    });

    for (let month = 0; month < 12; month++) {
        const date = new Date(year, month, 1);
        labels.push(formatter.format(date));
    }

    return labels;
};

const calcAi360ChartData = ({
    cars,
    electricityPrice,
    totalConsumptionMonthly,
    gridSupplyMonthly,
    autarky,
    batteryCapacity,
    wallboxConsumption,
    heatPumpConsumption,
    houseConsumption
}) => {

    // user values
    const wallboxConsumptionYearly = parseInt(cars.reduce((totalConsumption, distanceInKm) => {
        const consumption = distanceInKm === 10000
        ? 1800
        : distanceInKm === 15000
            ? 2000
            : distanceInKm === 30000 ? 2100 : 0;
        return totalConsumption + (distanceInKm / consumption)
    }, 0));
    // const wallboxConsumptionYearly = wallboxConsumption; // car
    const heatPumpConsumptionYearly = heatPumpConsumption;
    const houseConsumptionYearly = houseConsumption;
    const totalConsumptionYearly = wallboxConsumptionYearly + heatPumpConsumptionYearly + houseConsumptionYearly;

    const electricityPriceInEur = electricityPrice / 100;

    const totalConsumptionMonthlyCosts = totalConsumptionMonthly.map(value => value * electricityPriceInEur);
    const gridSupplyMonthlyCosts = gridSupplyMonthly.map(value => value * electricityPriceInEur);

    const totalConsumptionSum = totalConsumptionMonthly.reduce((sum, value) => sum + value, 0);
    //const batteryCapacity = 17.5;
    const totalConsumptionSumCost = totalConsumptionSum * electricityPriceInEur;
    const totalConsumptionSumCostWithPVandBattery = totalConsumptionSum * (1 - (autarky / 100));

    const batteryPotentialInPercent = batteryCapacity / ((heatPumpConsumptionYearly + houseConsumptionYearly)/365) * ((heatPumpConsumptionYearly + houseConsumptionYearly) / totalConsumptionYearly);
    // const batteryPotentialInPercent = batteryCapacity / ((heatPumpConsumptionYearly + houseConsumptionYearly)/30) * ((heatPumpConsumptionYearly + houseConsumptionYearly) / totalConsumptionYearly);
    const wallboxPotentialInPercent = (0.9 * wallboxConsumptionYearly) / totalConsumptionYearly;
    const heatPumpPotentialInPercent = (0.2 * heatPumpConsumptionYearly) / totalConsumptionYearly;
    const flexPotential = batteryPotentialInPercent + wallboxPotentialInPercent + heatPumpPotentialInPercent;
    const maxSavingsInPercent = flexPotential * 0.2; // if flexpotential is 100% we get 20% savings (max.)

    const module3DataCosts = totalConsumptionMonthlyCosts.map((totalMonthlyValue, index) => {
        const gridSupplyMonthyValue = gridSupplyMonthlyCosts[index];
        const reducedValue = gridSupplyMonthyValue - (totalMonthlyValue * maxSavingsInPercent);
        return Math.max(0, reducedValue);
    });

    //const module3DataCosts = gridSupplyMonthlyCosts.map(value => Math.max(0, value * (1 - maxSavingsInPercent)));

    // console.log({
    //     wallboxConsumptionYearly: wallboxConsumptionYearly,
    //     heatPumpConsumptionYearly: heatPumpConsumptionYearly,
    //     houseConsumptionYearly: houseConsumptionYearly,
    //     totalConsumptionYearly: totalConsumptionYearly,
    //     totalConsumptionMonthlyCosts: totalConsumptionMonthlyCosts,
    //     gridSupplyMonthlyCosts: gridSupplyMonthlyCosts,
    //     totalConsumptionSum: totalConsumptionSum,
    //     batteryPotentialInPercent: batteryPotentialInPercent,
    //     wallboxPotentialInPercent: wallboxPotentialInPercent,
    //     heatPumpPotentialInPercent: heatPumpPotentialInPercent,
    //     flexPotential: flexPotential,
    //     maxSavingsInPercent: maxSavingsInPercent
    // })

    return {
        pre_cost_total_eur: totalConsumptionMonthlyCosts,
        rest_cost_with_ai_360_sum_monthly: gridSupplyMonthlyCosts,
        rest_cost_with_ai_360_sum_monthly_module3: module3DataCosts,
    }
}

const AI360Chart = ({
    chartData,

}) => {

    console.log('chartData', chartData);

    const data = {
        labels: getMonthLabelsForCurrentYear(),
        datasets: [
            {
                label: 'Kein E3/DC',
                data: chartData.pre_cost_total_eur,
                backgroundColor: 'rgba(0, 164, 207, 1)',
                borderRadius: {
                    topLeft: 20, // Radius für obere linke Ecke
                    topRight: 20, // Radius für obere rechte Ecke
                },
            },
            {
                label: 'Fix Tarif (PV + Speicher)',
                data: chartData.rest_cost_with_ai_360_sum_monthly,
                backgroundColor: 'rgba(3, 100, 127, 1)',
                borderRadius: {
                    topLeft: 20, // Radius für obere linke Ecke
                    topRight: 20, // Radius für obere rechte Ecke
                },
            },
            {
                label: 'Modul AI 360°',
                data: chartData.rest_cost_with_ai_360_sum_monthly_module3,
                backgroundColor: 'rgba(121, 180, 28, 1)',
                borderRadius: {
                    topLeft: 20, // Radius für obere linke Ecke
                    topRight: 20, // Radius für obere rechte Ecke
                },
            },
        ],
    };

    const options = {
        //maintainAspectRatio: false,
        devicePixelRatio: 4,
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
        },
        // scale: 0.5,
        scales: {
            x: {
                ticks: {
                    font: {
                        size: 12, // Schriftgröße der X-Achse
                    },
                },
            },
            y: {
                ticks: {
                    font: {
                        size: 12, // Schriftgröße der Y-Achse (optional)
                    },
                    callback: (value) => `${value} €`
                },
            },
        }
    };

    return <Bar data={data} options={options} />;
};

export {
    AI360Chart,
    calcAi360ChartData
};
